/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_Right_TitleInputs */

const cs_builder_prop_right_title = /** @type {(inputs: Builder_Prop_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pravý titul`)
};

const en_builder_prop_right_title = /** @type {(inputs: Builder_Prop_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right title`)
};

/**
* | output |
* | --- |
* | "Right title" |
*
* @param {Builder_Prop_Right_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_right_title = /** @type {((inputs?: Builder_Prop_Right_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_Right_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_right_title(inputs)
	return cs_builder_prop_right_title(inputs)
});